import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import FsStore from './pages/FsStore';
import NotFound from './pages/NotFound';
import Home from './pages/Home';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/invoice/:orderId/:uuid',
    element: <FsStore />,
  },
  {
    // every other URL renders the 404 page
    path: '*',
    element: <NotFound />,
  },
]);

// NOTE: intentionally NOT wrapped in <React.StrictMode>. In dev, StrictMode
// double-mounts every component, which races with @react-pdf/renderer's async
// PDF generation and can leave the viewer blank until a manual reload.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);
